var SceneConifg = {
  REGISTERED_PROTOCOLS: {}
};
export { SceneConifg };